exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".display-none[data-v-2ac81fec]{display:none!important}#objectGoal[data-v-2ac81fec]{width:135px;font-family:Roboto;font-size:19px;color:#9f9f9f}#objectGoal[data-v-2ac81fec],#raised[data-v-2ac81fec]{overflow:visible;white-space:nowrap;text-align:left;font-style:normal;font-weight:400;margin:0 auto}#raised[data-v-2ac81fec]{width:214px;font-family:Nunito;font-size:50px;color:#000}", ""]);

// exports
